"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
// import { MdSubtitles } from 'react-icons/md'
// import { AiFillBook, AiOutlineCloseCircle } from 'react-icons/ai'
const react_bootstrap_1 = require("react-bootstrap");
const SelectSearch_1 = __importDefault(require("../../components/SelectSearch"));
function chapterObject(title, sections = []) {
    return { type: 'chapter', title: title, sections: sections };
}
function sectionObject(title, page_id) {
    return { type: 'section', title: title, page_id: page_id };
}
function reducer(content_table, action) {
    switch (action.type) {
        case 'set state':
            console.log('set state', action.state);
            return action.state;
        case 'add element':
            return [...content_table, action.element];
        case 'change element':
            return content_table === null || content_table === void 0 ? void 0 : content_table.map((element, index) => {
                if (index == action.index)
                    return action.element;
                return element;
            });
        case 'remove element':
            return content_table.filter((element, index) => {
                return index != action.index;
            });
        case 'left up element':
            let leftup = [...content_table];
            if (action.index >= 1)
                [leftup[action.index - 1], leftup[action.index]] = [leftup[action.index], leftup[action.index - 1]];
            return leftup;
        case 'left down element':
            let leftdown = [...content_table];
            if (action.index < leftdown.length - 1)
                [leftdown[action.index + 1], leftdown[action.index]] = [leftdown[action.index], leftdown[action.index + 1]];
            return leftdown;
        default: return content_table;
    }
}
const elementTypes = {
    chapter: react_1.default.createElement("div", null,
        react_1.default.createElement("i", { className: "bi bi-fill-book" }),
        "\u0641\u0635\u0644"),
    section: react_1.default.createElement("div", null,
        react_1.default.createElement("i", { className: "bi bi-journal-bookmark-fill" }),
        "\u0639\u0646\u0648\u0627\u0646")
};
function ContentTableEditor(props) {
    var _a;
    const props_content_table = props.content_table;
    const pages = props.pages;
    const editContentTable = props.editContentTable;
    const [elements, dispatch] = react_1.default.useReducer(reducer, []);
    const [stateisset, setstateisset] = react_1.default.useState(false);
    react_1.default.useEffect(() => {
        if ((props_content_table === null || props_content_table === void 0 ? void 0 : props_content_table.length) && !stateisset) {
            dispatch({ type: 'set state', state: props_content_table });
            setstateisset(true);
        }
        // console.log('elements', props_content_table)
    }, [props_content_table]);
    react_1.default.useEffect(() => {
        editContentTable(elements);
    }, [elements]);
    return react_1.default.createElement("div", null, elements === null || elements === void 0 ? void 0 :
        elements.map((element, index) => {
            var _a;
            if (element.type == 'chapter') {
                // console.log('element.sections', element.sections)
                return react_1.default.createElement("div", { className: 'border rounded', key: index },
                    react_1.default.createElement("div", { className: 'd-flex flex-row justify-content-end h-100 ' },
                        react_1.default.createElement("i", { className: "bi bi-x-circle", onClick: () => { dispatch({ type: 'remove element', index: index }); } })),
                    "chapter",
                    react_1.default.createElement("div", { className: 'd-flex flex-column' },
                        react_1.default.createElement("input", { type: 'text', placeholder: '\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0641\u0635\u0644', onChange: e => {
                                dispatch({ type: 'change element', index: index, element: chapterObject(e.target.value, element.sections) });
                            }, value: element.title }),
                        react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 },
                            react_1.default.createElement(ContentTableEditor, { pages: pages, editContentTable: (elements) => {
                                    dispatch({ type: 'change element', index: index, element: chapterObject(element.title, elements) });
                                }, content_table: (_a = element.sections) !== null && _a !== void 0 ? _a : [] }))));
            }
            else if (element.type == 'section') {
                // console.log('section', element)
                return react_1.default.createElement("div", { className: 'mr-2', key: index },
                    react_1.default.createElement("div", { className: 'd-flex flex-row justify-content-end h-100 ' },
                        react_1.default.createElement("i", { className: "bi bi-x-circle", onClick: () => { dispatch({ type: 'remove element', index: index }); } })),
                    "section",
                    react_1.default.createElement("div", { className: 'd-flex flex-row justify-content-center ' },
                        react_1.default.createElement("input", { type: 'text', placeholder: 'section title', onChange: e => {
                                dispatch({ type: 'change element', index: index, element: sectionObject(e.target.value, element.page_id) });
                            }, value: element.title }),
                        react_1.default.createElement(SelectSearch_1.default, { options: pages, setSelectedValue: (option_value) => {
                                dispatch({ type: 'change element', index: index, element: sectionObject(element.title, option_value) });
                                // dispatch({ type: 'change element', index: index, element: sectionObject(e.target.value, element.page_id) })
                                // console.log('option', pages)
                            }, label: '\u0627\u062E\u062A\u0631 \u0635\u0641\u062D\u0629', valueKeyWord: 'id', nameKeyWord: 'title', defaultValue: element.page_id })));
            }
        }),
        react_1.default.createElement(react_bootstrap_1.Col, { xs: 2, className: 'mx-auto' },
            react_1.default.createElement(react_bootstrap_1.Dropdown, { onSelect: (e) => {
                    if (e == 'chapter')
                        dispatch({ type: 'add element', element: chapterObject('', []) });
                    else if (e == 'section')
                        dispatch({ type: 'add element', element: sectionObject('', '') });
                } },
                react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "success", id: "dropdown-basic" }, "\u0641\u0635\u0644 \u0627\u0645 \u0639\u0646\u0648\u0627\u0646"),
                react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, null, (_a = Object.keys(elementTypes)) === null || _a === void 0 ? void 0 : _a.map(function (key, index) {
                    return react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { key: index, eventKey: key }, elementTypes[key]);
                })))));
}
exports.default = ContentTableEditor;
